import { render, staticRenderFns } from "./SchedulePlanning.vue?vue&type=template&id=b2446d54"
import script from "./SchedulePlanning.vue?vue&type=script&lang=js"
export * from "./SchedulePlanning.vue?vue&type=script&lang=js"
import style0 from "./SchedulePlanning.vue?vue&type=style&index=0&id=b2446d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports